'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosCloudUploadOutline = function IoIosCloudUploadOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm12.6 20.3l-0.9-0.8 5.8-5.9 5.9 5.9-1 0.8-4.3-4.2v18.9h-1.2v-18.9z m16.1-5.9c3.5 0 6.3 3 6.3 6.6s-2.9 6.5-6.4 6.5h-7.9v-1.2h7.9c2.9 0 5.2-2.4 5.2-5.3s-2.3-5.5-5.2-5.5l-1.2 0v-1.6c0-4.4-3.6-7.7-7.9-7.7-2.9 0-5.7 1.8-7 4.5l-0.5 1-1.1-0.5c-0.4-0.2-1-0.3-1.5-0.3-1.7 0-3.2 1.3-3.5 3l0 0.7-0.7 0.2c-2.4 0.8-4 3.1-4 5.6 0 3.2 2.6 5.8 5.8 5.8h7.1v1.3h-7.1c-3.9 0-7-3.1-7-7 0-3.2 2-5.8 4.8-6.8 0.4-2.1 2.2-4 4.6-4 0.8 0 1.4 0.1 2 0.5 1.5-3.1 4.6-5.2 8.2-5.2 5 0 9.1 4.1 9.1 9.1 0 0 0 0.2 0 0.3z' })
        )
    );
};

exports.default = IoIosCloudUploadOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-cloud-upload-outline.js
// module id = 2357
// module chunks = 0